export default function DcChargerTitle() {
  return (
    <section className="blade-padding-top">
      <section className=" max-w-xl lg:max-w-7xl mx-auto w-11/12 px-2 md:px-4">
        <h3 className="text-center font-gilroy">
          Charge faster, Operate smarter <br /> Go further with VerdeMobility DC Charging Solutions
        </h3>
      </section>
    </section>
  );
}
